/**
* @Author: zachalam
* @Date:   2017-03-15T13:45:22-07:00
* @Email:  zach@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-17T10:20:39-07:00
*/



import React, { Component } from 'react';

import Container from '../../blocks/Container';
import Button from '../../blocks/Button';
import InputGroup from '../../blocks/InputGroup';
import Panel from '../../common/Panel';
import Header from '../../blocks/Header';
import Headline from '../../common/Headline';
import TextInput from '../../common/TextInput';
import Text from '../../common/Text';
import Checkbox from '../../common/Checkbox';


class Deactivate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      password: '',
      agreed: false
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.passChange = this.passChange.bind(this);
    this.agreeChange = this.agreeChange.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    //console.log("yolo");
    this.props.deactivate(this.state.password);
  }

  passChange(e) { this.setState({password: e.target.value })}
  agreeChange(e) { this.setState({agreed: !this.state.agreed })}

  render() {

      let allowSubmit = Boolean(this.state.password) && Boolean(this.state.agreed);

      return (
        <Container screenTop width='thin'>
          <Panel withHeader>
            <Header>
              <Headline>Disable Account</Headline>
            </Header>
            <Text size='SM'>This will disable your profile and delete any trips you’ve made. Some information may still be visible to others, such as your username and any messages you sent. You can always reactivate your account by logging back in.</Text>

            <InputGroup vertical inputLabel="Current Password" errors={this.props.errors.password}>
              <TextInput type="password" error={this.props.errors.password} onChange={this.passChange} value={this.state.password} />
            </InputGroup>

            <Checkbox type="checkbox" onChange={this.agreeChange} value={this.state.agreed}>
             <span> I agree with the terms above. </span>
           </Checkbox>

            <Button variant='primary' onClick={this.handleSubmit} disabled={!allowSubmit}>Deactivate My Account</Button>
          </Panel>
        </Container>
      );
  }
}



export default Deactivate;



// WEBPACK FOOTER //
// ./src/components/pages/Settings/Deactivate.jsx